import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 16.505v-6.75m0 0 3 3m-3-3-3 3m-2.25 6.75a4.5 4.5 0 0 1-1.41-8.775A5.25 5.25 0 0 1 15.573 8.4a3 3 0 0 1 3.758 3.848A3.751 3.751 0 0 1 18 19.505z"
    }, null, -1)
  ])))
}
export default { render: render }